<div
  style="
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 5px;
    width: 100%;
    height: auto;
    margin-top: 40px;
  "
>
  <!-- Chart 1 -->
  <div style="flex: 1; min-width: 49%; max-width: 49%; height: 560px; border: 2px solid green">
    <div>
      <div class="title">TOP 10 ACTIVE ORDERS</div>
      @if (chartOptionsActiveOrders && chartOptionsActiveOrders.series && chartOptionsActiveOrders?.series?.length) {
        <apx-chart
          [series]="chartOptionsActiveOrders.series"
          [chart]="chartOptionsActiveOrders.chart"
          [labels]="chartOptionsActiveOrders.labels"
          [dataLabels]="chartOptionsActiveOrders.dataLabels"
          [colors]="chartOptionsActiveOrders.colors"
          [tooltip]="chartOptionsActiveOrders.tooltip"
          [legend]="chartOptionsActiveOrders.legend"
          [title]="chartOptionsActiveOrders.title"
        >
        </apx-chart>
      }
    </div>
  </div>

  <!-- Chart 2 -->
  <div style="flex: 1; min-width: 49%; max-width: 49%; height: 560px; border: 2px solid green">
    <div>
      <div class="title">TOP 5 INVOICE AMOUNT</div>
      @if (
        chartOptionsInvoiceAmounts && chartOptionsInvoiceAmounts.series && chartOptionsInvoiceAmounts?.series?.length
      ) {
        <apx-chart
          [series]="chartOptionsInvoiceAmounts.series"
          [chart]="chartOptionsInvoiceAmounts.chart"
          [labels]="chartOptionsInvoiceAmounts.labels"
          [dataLabels]="chartOptionsInvoiceAmounts.dataLabels"
          [colors]="chartOptionsInvoiceAmounts.colors"
          [tooltip]="chartOptionsInvoiceAmounts.tooltip"
          [legend]="chartOptionsInvoiceAmounts.legend"
          [title]="chartOptionsInvoiceAmounts.title"
          [grid]="chartOptionsInvoiceAmounts.grid"
          [xaxis]="chartOptionsInvoiceAmounts.xaxis"
          [yaxis]="chartOptionsInvoiceAmounts.yaxis"
        >
        </apx-chart>
      }
    </div>
  </div>
</div>

<div
  style="
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    gap: 5px;
    margin-top: 20px;
  "
>
  @for (chart of chartOptionsTotals; track chart; let i = $index) {
    <div style="flex: 1; min-width: 24%; max-width: 24%; height: 250px; border: 2px solid green">
      @if (chart && chart.series && chart.series.length > 0) {
        <apx-chart
          [series]="chart.series"
          [chart]="chart.chart"
          [labels]="chart.labels"
          [colors]="chart.colors"
          [plotOptions]="chart.plotOptions"
          [dataLabels]="chart.dataLabels"
          [tooltip]="chart.tooltip"
          [legend]="chart.legend"
          [responsive]="chart.responsive"
        >
        </apx-chart>
      }
    </div>
  }
</div>

@if (isProcessing) {
  <div class="processing-wrapper">
    <div class="processing-circle"></div>
    <div class="processing-text">
      {{ "app.misc.processing" | translate }}
    </div>
  </div>
}
